const ONE_GB = 1024 * 1024 * 1024;
const baseSseData = {
    timestamp: Date.now(),
    cards: [
        {
            card_id: "atlas0",
            card_type: "atlas",
            card_serial_number: "0049",
            card_state: "Active",
            card_state_message: "",
            extracting_data: true,
            data_rate: 9999,
            card_healthy: true,
            card_errors: [],
            nist_continuous_success: true,
            nist_continuous_timestamp: Date.now()
        },
        {
            card_id: "atlas1",
            card_type: "atlas",
            card_serial_number: "0049",
            card_state: "Pending",
            card_state_message: "NIST startup test suite in progress—this may take up to 10 minutes.",
            extracting_data: false,
            data_rate: 0,
            card_healthy: true,
            card_errors: [],
            nist_continuous_success: false
        },
        {
            card_id: "atlas2",
            card_type: "atlas",
            card_serial_number: "0049",
            card_state: "Error",
            card_state_message: "",
            extracting_data: false,
            data_rate: 0,
            card_healthy: false,
            card_errors: [
                {
                    timestamp: Date.now(),
                    error_msg: "Card has experienced an error."
                }
            ],
            nist_continuous_success: false,
            nist_continuous_timestamp: Date.now()
        }
    ],
    entropy_stream_frozen: false,
    system_errors: [],
    system_metrics: {
        cpu: {
            utilization: 0.5,
            cores: 16
        },
        memory: {
            total: 32 * ONE_GB,
            available: 16 * ONE_GB,
            used: 16 * ONE_GB
        }
    },
    network_metrics: [
        {
            interface: "enp1s0f1",
            ip_address: "111.111.111.111",
            subnet_mask: "255.255.255.0",
            gateway: "111.111.111.111",
            mac_address: "ec:e7:a7:07:9c:bd",
            mtu: 1500,
            interface_speed_mbps: 1000.0,
            rx_rate_mbps: 0,
            tx_rate_mbps: 0
        },
        {
            interface: "enp1s0f2",
            ip_address: "222.222.222.222",
            subnet_mask: "255.255.255.0",
            gateway: "222.222.222.222",
            mac_address: "ec:e7:a7:07:9c:bd",
            mtu: 1500,
            interface_speed_mbps: 2000.0,
            rx_rate_mbps: 0,
            tx_rate_mbps: 0
        },
        {
            interface: "enp1s0f3",
            ip_address: "333.333.333.333",
            subnet_mask: "255.255.255.0",
            gateway: "333.333.333.333",
            mac_address: "ec:e7:a7:07:9c:bd",
            mtu: 1500,
            interface_speed_mbps: 3000.0,
            rx_rate_mbps: 0,
            tx_rate_mbps: 0
        }
    ],
    node_utilization: {},
    utilization: {
        consumption: {
            curr_entropy_bps: 0,
            available_entropy: 400 * ONE_GB,
            entropy_capacity: 400 * ONE_GB
        },
        requests: {
            successful_reqs: 10,
            failed_reqs: 2
        },
        latency: {
            p_9999: 8.01,
            p_999: 7.98,
            p_99: 7.83,
            p_95: 7.19,
            p_50: 2.8
        }
    },
    entropy_clients_by_node: {
        "node-1": [
            {
                ip: "127.0.0.1",
                user_agent: "curl/7.81.0",
                stats: {
                    m_15: {
                        num_requests: 2,
                        entropy_requested_b: 32
                    },
                    m_30: {
                        num_requests: 4,
                        entropy_requested_b: 64
                    },
                    h_1: {
                        num_requests: 8,
                        entropy_requested_b: 128
                    },
                    h_2: {
                        num_requests: 16,
                        entropy_requested_b: 256
                    },
                    h_4: {
                        num_requests: 32,
                        entropy_requested_b: 512
                    },
                    d_1: {
                        num_requests: 64,
                        entropy_requested_b: 1024
                    },
                    w_1: {
                        num_requests: 128,
                        entropy_requested_b: 2048
                    }
                }
            }
        ],
        "node-2": [
            {
                ip: "127.0.0.1",
                user_agent: "python-requests/2.32.3",
                stats: {
                    m_15: {
                        num_requests: 2,
                        entropy_requested_b: 32
                    },
                    m_30: {
                        num_requests: 4,
                        entropy_requested_b: 64
                    },
                    h_1: {
                        num_requests: 8,
                        entropy_requested_b: 128
                    },
                    h_2: {
                        num_requests: 16,
                        entropy_requested_b: 256
                    },
                    h_4: {
                        num_requests: 32,
                        entropy_requested_b: 512
                    },
                    d_1: {
                        num_requests: 64,
                        entropy_requested_b: 1024
                    },
                    w_1: {
                        num_requests: 128,
                        entropy_requested_b: 2048
                    }
                }
            },
            {
                ip: "33.33.33.33",
                user_agent: "curl/7.81.0",
                stats: {
                    m_15: {
                        num_requests: 2,
                        entropy_requested_b: 32
                    },
                    m_30: {
                        num_requests: 4,
                        entropy_requested_b: 64
                    },
                    h_1: {
                        num_requests: 8,
                        entropy_requested_b: 128
                    },
                    h_2: {
                        num_requests: 16,
                        entropy_requested_b: 256
                    },
                    h_4: {
                        num_requests: 32,
                        entropy_requested_b: 512
                    },
                    d_1: {
                        num_requests: 64,
                        entropy_requested_b: 1024
                    },
                    w_1: {
                        num_requests: 128,
                        entropy_requested_b: 2048
                    }
                }
            }
        ]
    },
    entropy_clients: [
        {
            ip: "127.0.0.1",
            user_agent: "curl/7.81.0",
            stats: {
                m_15: {
                    num_requests: 2,
                    entropy_requested_b: 32
                },
                m_30: {
                    num_requests: 4,
                    entropy_requested_b: 64
                },
                h_1: {
                    num_requests: 8,
                    entropy_requested_b: 128
                },
                h_2: {
                    num_requests: 16,
                    entropy_requested_b: 256
                },
                h_4: {
                    num_requests: 32,
                    entropy_requested_b: 512
                },
                d_1: {
                    num_requests: 64,
                    entropy_requested_b: 1024
                },
                w_1: {
                    num_requests: 128,
                    entropy_requested_b: 2048
                }
            }
        },
        {
            ip: "127.0.0.1",
            user_agent: "python-requests/2.32.3",
            stats: {
                m_15: {
                    num_requests: 2,
                    entropy_requested_b: 32
                },
                m_30: {
                    num_requests: 4,
                    entropy_requested_b: 64
                },
                h_1: {
                    num_requests: 8,
                    entropy_requested_b: 128
                },
                h_2: {
                    num_requests: 16,
                    entropy_requested_b: 256
                },
                h_4: {
                    num_requests: 32,
                    entropy_requested_b: 512
                },
                d_1: {
                    num_requests: 64,
                    entropy_requested_b: 1024
                },
                w_1: {
                    num_requests: 128,
                    entropy_requested_b: 2048
                }
            }
        },
        {
            ip: "33.33.33.33",
            user_agent: "curl/7.81.0",
            stats: {
                m_15: {
                    num_requests: 2,
                    entropy_requested_b: 32
                },
                m_30: {
                    num_requests: 4,
                    entropy_requested_b: 64
                },
                h_1: {
                    num_requests: 8,
                    entropy_requested_b: 128
                },
                h_2: {
                    num_requests: 16,
                    entropy_requested_b: 256
                },
                h_4: {
                    num_requests: 32,
                    entropy_requested_b: 512
                },
                d_1: {
                    num_requests: 64,
                    entropy_requested_b: 1024
                },
                w_1: {
                    num_requests: 128,
                    entropy_requested_b: 2048
                }
            }
        }
    ]
};
export default baseSseData;
